// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__B8i0E","col":"styles_col__1FYo5"};